export const environment = {
  production: true,
  portalDomain: "https://onepass.cic.hk/",
  apiDomain: "https://onepass.cic.hk/api/",
  iamsmartDomain: "https://onepass.cic.hk/iamsmart/",
  companyGroupId: "oty8izdibnzYNAaKy697",
  oktaDomain: "onepass-sso.cic.hk",
  idpReturnAppId: "0oa8m33chjQ7NbLvH697",
  oktaAuthAppId: "0oa8m4ch8lv9BsmZY697",
  oktaAuthAppIdHighRisk: "0oa8m4ch8lv9BsmZY697",
  oktaAuthAppIdLowRisk: "0oa8m4ch8lv9BsmZY697",
  oktaClientId: "0oa8m1rjddUUcSadg697",
  oktaClientIdHighRisk: "0oa8m1rjddUUcSadg697",
  oktaClientIdLowRisk: "0oa8m1rjddUUcSadg697",
  supportNo: "+852 2100 9000",
  recaptchaV2SiteKey: "6LcN6z8rAAAAAHjEFZAymYxmK4OJctDYx935Or1d",
  recaptchaV3SiteKey: "6Lfi6j8rAAAAAGQqZLNbgWBsebRz0vmW2l6ZtbM4",
  plugins: [],
};
